import api from 'services/api'

export const fetchMetrics = () =>
  api.get(`/metrics`,)